module.exports = __webpack_public_path__ + "static/media/hoppa.848fd1a2.mp3";